import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { MULTIPLE_CARRIERS, AIRLINES_PRICES_TITLES } from '@flight-results/constants/filters.constants';

@Pipe({
  name: 'airlineName',
  standalone: false
})
export class AirlineNamePipe implements PipeTransform {

  constructor(private readonly transloco: TranslocoService) { }

  transform(code: string, ...args: string[]): string {
    return code === MULTIPLE_CARRIERS ? this.transloco.translate(AIRLINES_PRICES_TITLES[MULTIPLE_CARRIERS]) : code;
  }
}
